
export const asNonSupport = {
    data: `<svg width="40" height="40" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
      <path d="M26.36 17.88C26.76 17 27 16.04 27 15C27 11.14 23.86 8 20 8C18.96 8 18 8.24 17.12 8.64L26.36 17.88Z" />
      <path d="M20 0C8.96 0 0 8.96 0 20C0 31.04 8.96 40 20 40C31.04 40 40 31.04 40 20C40 8.96 31.04 0 20 0ZM4 20C4 16.3 5.26 12.9 7.38 10.2L13.1 15.92C13.52 19.04 15.96 21.5 19.08 21.9L23.48 26.3C22.34 26.1 21.18 26 20 26C15.36 26 11.1 27.6 7.72 30.24C5.4 27.46 4 23.9 4 20ZM20 36C16.52 36 13.32 34.88 10.7 33C13.32 31.12 16.52 30 20 30C23.48 30 26.68 31.12 29.3 33C26.68 34.88 23.48 36 20 36ZM32.62 29.8L10.2 7.38C12.9 5.26 16.3 4 20 4C28.84 4 36 11.16 36 20C36 23.7 34.74 27.08 32.62 29.8Z"/>
    </svg>
    `,
    name: 'nonSupport',
  };
  